import TomSelect from 'tom-select'

export default class TomSelectInput extends HTMLElement {
  connectedCallback() {
    this._init()

    this._beforeMorphHandler = (event) => {
      if (this === event.target || this.contains(event.target)) {
        this._destroy()
      }
    }
    this._reinitHandler = () => {
      if (!this.tomSelect) this._init()
    }

    document.addEventListener(
      'turbo:before-morph-element',
      this._beforeMorphHandler
    )
    document.addEventListener('turbo:morph', this._reinitHandler)
    document.addEventListener('turbo:frame-render', this._reinitHandler)
  }

  disconnectedCallback() {
    document.removeEventListener(
      'turbo:before-morph-element',
      this._beforeMorphHandler
    )
    document.removeEventListener('turbo:morph', this._reinitHandler)
    document.removeEventListener('turbo:frame-render', this._reinitHandler)
    this._destroy()
  }

  _init() {
    if (this.tomSelect) return
    const select = this.querySelector('select')
    if (!select) return

    const isMultiple = select.hasAttribute('multiple')
    const hasBlank = Array.from(select.options).some((o) => o.value === '')
    const plugins = isMultiple || hasBlank ? ['remove_button'] : []

    this.tomSelect = new TomSelect(select, {
      plugins,
      create: false,
      sortField: false,
      onInitialize() {
        // TomSelect replaces the <select> in the DOM; keep label[for] pointing at the original select id
        const label = document.querySelector(`label[for="${select.id}"]`)
        if (label) label.setAttribute('for', select.id)
      }
    })
  }

  _destroy() {
    try {
      this.tomSelect?.destroy()
    } catch (_e) {
      // tom-select DOM may already be gone after morph
    }
    this.tomSelect = null
  }
}
